import React, { createContext, FC, useContext, useEffect, useReducer } from "react";

import { ITransactionsContext, State, Action } from "./type";

const TransactionsContext = createContext<ITransactionsContext | undefined>(undefined);

export const transactionsReducer = (state: State, action: Action): State => {
  switch (action.type) {
    case "INIT": {
      return { ...state, ...action.payload };
    }
    case "MODAL": {
      return { ...state, modals: action.modals };
    }
    case "FILTER": {
      return { ...state, filter: action.filter, transactions: action.transactions };
    }
    case "ERROR": {
      return { ...state, error: true };
    }
    default: {
      throw new Error("Unhandled action");
    }
  }
};

const init = (): State => ({
  filter: {
    periodFilter: "LAST_7_DAYS",
    startDate: "",
    endDate: "",
  },
  modals: {
    filterModalOpen: false,
    threeYearsModalOpen: false,
    legacyUserModalOpen: false,
  },
  tokens: {
    jwt: localStorage.getItem("session-token") || "",
    apiDomain: localStorage.getItem("apiDomain") || "",
  },
  transactions: JSON.parse(localStorage.getItem("transactions") || "[]"),
  error: false,
});

const TransactionsProvider: FC = ({ children }) => {
  const [state, dispatch] = useReducer(transactionsReducer, undefined, init);
  const value = { state, dispatch };

  useEffect(() => {
    if (state.transactions) {
      localStorage.setItem("transactions", JSON.stringify(state.transactions));
    }
    localStorage.setItem("apiDomain", state.tokens.apiDomain);
  }, [state]);

  return <TransactionsContext.Provider value={value}>{children}</TransactionsContext.Provider>;
};

const useTransactions = () => {
  const context = useContext(TransactionsContext);
  if (context === undefined) {
    throw new Error("useTransactions must be used within a TransactionsContext");
  }
  return context;
};

export { TransactionsProvider, useTransactions };
